var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{key:_vm.key,ref:"comments",class:_vm.reactiveClass,attrs:{"size":"sm"},on:{"change":_vm.saveComments},model:{value:(_vm.form.comments),callback:function ($$v) {_vm.$set(_vm.form, "comments", $$v)},expression:"form.comments"}})
}
var staticRenderFns = []

export { render, staticRenderFns }